export default __webpack_public_path__ + "static/media/img10.b7857467.png";